const ITEMS = ["Air Cargo", "Sea Cargo", "Door To Door", "Local Deliveries", "Overseas Pickups", "Customs Brokerage", "Same-Day Delivery", "Warehousing"];

export default function Marquee() {
  return (
    <div className="relative border-y border-black/5 bg-[#F5F5F7] py-6 overflow-hidden">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((rep) => (
          <div key={rep} className="flex items-center" aria-hidden={rep === 1}>
            {ITEMS.map((t, i) => (
              <span key={`${rep}-${i}`} className="flex items-center">
                <span className="font-display text-2xl font-bold text-[#1F1F1F]/80 sm:text-3xl px-8">{t}</span>
                <span className="h-2 w-2 rounded-full bg-[#E31B23]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
